import React from 'react';
// import cx from 'classnames';
import styles from './SectionContainer.module.less';

const SectionContainer = ({ children, ...props }) => {
  return (
    <div {...props}>
      <div className={styles.contentContainer}>{children}</div>
    </div>
  );
};

export default SectionContainer;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/RegistryContainer/RegistryOnboardContainer/components/SectionContainer/SectionContainer.jsx